"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPhysicalProduct_1 = __importDefault(require("./isPhysicalProduct"));
const phProductsInArrCheck = (lineItems) => lineItems.reduce((acc, lineItem) => {
    if (acc.hasPhProduct && acc.hasBasicPhProduct && acc.hasPhSubscriptionProduct)
        return acc;
    const { isPhProduct, isBasicPhProduct, isPhSubscriptionProduct } = isPhysicalProduct_1.default(lineItem.variant.attributes);
    if (isPhProduct)
        acc.hasPhProduct = isPhProduct;
    if (isBasicPhProduct)
        acc.hasBasicPhProduct = isBasicPhProduct;
    if (isPhSubscriptionProduct)
        acc.hasPhSubscriptionProduct = isPhSubscriptionProduct;
    return acc;
}, { hasPhProduct: false, hasBasicPhProduct: false, hasPhSubscriptionProduct: false });
exports.default = phProductsInArrCheck;
//# sourceMappingURL=phProductsInArrCheck.js.map